import { render } from "./PartnersView.vue?vue&type=template&id=2b51dffc&ts=true"
import script from "./PartnersView.vue?vue&type=script&lang=ts"
export * from "./PartnersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__